const body = document.querySelector('body');
const lightboxTrigger = document.querySelectorAll('.lightbox');
const lightbox = document.querySelectorAll('.custom-lightbox');
const lightboxContent = lightbox.
lightbox

addEventListener("DOMContentLoaded", () => {
    let activeLightbox = false;
    
    // open lightbox trigger links
    lightboxTrigger.forEach(function(item){ 
        item.addEventListener('click', ()=> {
            lightboxTarget = item.getAttribute('data-lightbox');
            openLightbox(lightboxTarget);
            activeLightbox = true;
        });
    });

    // close lightbox content
    lightbox.forEach(function(item){
        let closelightboxBtn = item.querySelector('.custom-lightbox__content__close');

        closelightboxBtn.addEventListener('click', ()=> {
            closeLightbox();
        });
    });

    // close lightbox escape key
    document.addEventListener('keydown', function(e) {
        if(e.key === "Escape"){
            closeLightbox();
        }
    });

    // open lightbox function
    function openLightbox(item) {
        body.classList.add('lightbox-active')
        target = document.querySelector(item);
        target.classList.add('open');
    }

    // close lightbox function
    function closeLightbox() {
        activeLightbox = false;

        lightbox.forEach(function(item) { 
            if( item.classList.contains('open') ) {
                item.classList.remove('open');
            }
        });
        
        body.classList.remove('lightbox-active')
    }
});